/**
 * Swipe Feed — TikTok-style vertical product scroll
 * Borgovitto 2026
 */
(function () {
  'use strict';

  // ─── Core init ────────────────────────────────────────────────────
  function initSwipeFeed() {
    // Only activate on mobile
    if (window.innerWidth >= 750) return;

    document.querySelectorAll('[id^="swipe-track-"]').forEach(function (track) {
      const sectionId = track.id.replace('swipe-track-', '');
      const cards = Array.from(track.querySelectorAll('.swipe-card'));
      const dotsWrap = document.getElementById('swipe-dots-' + sectionId);
      const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.swipe-dot')) : [];

      if (!cards.length) return;

      let current = 0;
      let isAnimating = false;
      let startY = 0;
      let startX = 0;
      let dragging = false;

      // ── Initial layout ──
      cards.forEach(function (card, i) {
        card.style.transform = i === 0 ? 'translateY(0)' : 'translateY(100%)';
        card.style.opacity = i === 0 ? '1' : '0';
        card.style.zIndex = i === 0 ? '2' : '0';
      });

      // ── Navigate ──
      function goTo(next, dir) {
        if (isAnimating || next < 0 || next >= cards.length) return;
        isAnimating = true;

        const leaving = cards[current];
        const entering = cards[next];

        entering.style.transition = 'none';
        entering.style.transform = dir === 'up' ? 'translateY(100%)' : 'translateY(-100%)';
        entering.style.opacity = '0.4';
        entering.style.zIndex = '3';
        leaving.style.zIndex = '2';

        // Force reflow
        void entering.offsetHeight;

        const ease = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        entering.style.transition = 'transform 0.42s ' + ease + ', opacity 0.42s ease';
        leaving.style.transition = 'transform 0.42s ' + ease + ', opacity 0.42s ease';

        entering.style.transform = 'translateY(0)';
        entering.style.opacity = '1';
        leaving.style.transform = dir === 'up' ? 'translateY(-25%)' : 'translateY(25%)';
        leaving.style.opacity = '0';

        // Dots
        if (dots[current]) dots[current].classList.remove('swipe-dot--active');
        if (dots[next]) dots[next].classList.add('swipe-dot--active');

        function onEnd() {
          leaving.style.cssText = '';
          leaving.style.transform = dir === 'up' ? 'translateY(100%)' : 'translateY(-100%)';
          leaving.style.opacity = '0';
          leaving.style.zIndex = '0';
          entering.style.transition = '';
          entering.style.zIndex = '2';
          current = next;
          isAnimating = false;
          leaving.removeEventListener('transitionend', onEnd);
        }

        leaving.addEventListener('transitionend', onEnd, { once: true });
      }

      // ── Touch ──
      var intentDecided = false;
      var swipeIntent = false; // true = stiamo facendo swipe feed, false = scroll pagina

      track.addEventListener('touchstart', function (e) {
        // Non intercettare tap su pulsanti/link
        if (e.target.closest('button, a, input, select')) return;
        startY = e.touches[0].clientY;
        startX = e.touches[0].clientX;
        dragging = true;
        intentDecided = false;
        swipeIntent = false;
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        var dY = startY - e.touches[0].clientY;
        var dX = startX - e.touches[0].clientX;

        // Fase 1: decidere l'intenzione una volta sola appena il dito si muove
        if (!intentDecided) {
          var absY = Math.abs(dY);
          var absX = Math.abs(dX);
          // Aspettiamo almeno 5px di movimento prima di decidere
          if (absY < 5 && absX < 5) return;

          // Movimento prevalentemente orizzontale → cediamo al browser
          if (absX > absY) { dragging = false; return; }

          // Movimento verticale: controlliamo i limiti
          var atTop    = current === 0 && dY < 0;
          var atBottom = current === cards.length - 1 && dY > 0;
          if (atTop || atBottom) { dragging = false; return; }

          // Siamo nel mezzo del feed → prendiamo controllo
          intentDecided = true;
          swipeIntent   = true;
        }

        // Fase 2: una volta deciso che è uno swipe feed, blocchiamo sempre lo scroll pagina
        if (swipeIntent) e.preventDefault();
      }, { passive: false });

      track.addEventListener('touchend', function (e) {
        if (!dragging) return;
        dragging = false;
        if (!swipeIntent) return;
        var diff = startY - e.changedTouches[0].clientY;
        if (Math.abs(diff) < 40) return;
        goTo(current + (diff > 0 ? 1 : -1), diff > 0 ? 'up' : 'down');
      }, { passive: true });

      // ── Mouse wheel (desktop preview) ──
      var wheelTimer;
      track.addEventListener('wheel', function (e) {
        var atTop = current === 0 && e.deltaY < 0;
        var atBottom = current === cards.length - 1 && e.deltaY > 0;
        if (atTop || atBottom) return;
        e.preventDefault();
        clearTimeout(wheelTimer);
        wheelTimer = setTimeout(function () {
          goTo(current + (e.deltaY > 0 ? 1 : -1), e.deltaY > 0 ? 'up' : 'down');
        }, 60);
      }, { passive: false });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') goTo(current + 1, 'up');
        if (e.key === 'ArrowUp')   goTo(current - 1, 'down');
      });
    });
  }

  window.bvSwipeAddToCart = function (btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = '✓ Nel carrello';
      btn.classList.add('bv-added');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () {
        btn.textContent = orig; btn.disabled = false; btn.classList.remove('bv-added');
      }, 2200);
    })
    .catch(function () {
      btn.textContent = 'Errore';
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1500);
    });
  };

  var BV_WL_KEY = 'bv_wishlist_items';
  function bvWlGetItems() {
    try { return JSON.parse(localStorage.getItem(BV_WL_KEY) || '[]'); } catch(e) { return []; }
  }
  function bvWlSaveItems(list) {
    localStorage.setItem(BV_WL_KEY, JSON.stringify(list));
    localStorage.setItem('bv_wishlist', JSON.stringify(list.map(function(p){ return p.id; })));
  }
  window.bvSwipeWishlist = function (btn) {
    var productId = btn.getAttribute('data-product-id');
    var list = bvWlGetItems();
    var idx = list.findIndex ? list.findIndex(function(p){ return p.id === productId; })
                             : (function(){ for(var i=0;i<list.length;i++){ if(list[i].id===productId) return i; } return -1; })();
    if (idx > -1) {
      list.splice(idx, 1);
      btn.classList.remove('bv-wishlisted');
    } else {
      list.push({
        id: productId, title: btn.getAttribute('data-product-title') || '',
        vendor: btn.getAttribute('data-product-vendor') || '',
        price: btn.getAttribute('data-product-price') || '',
        image: btn.getAttribute('data-product-image') || '',
        url: btn.getAttribute('data-product-url') || '',
        variantId: btn.getAttribute('data-variant-id') || ''
      });
      btn.classList.add('bv-wishlisted');
      btn.style.transform = 'scale(1.25)';
      setTimeout(function () { btn.style.transform = ''; }, 220);
    }
    bvWlSaveItems(list);
    if (window.bvWishlistUpdate) window.bvWishlistUpdate();
  };
  function restoreWishlist() {
    bvWlGetItems().forEach(function (item) {
      var btn = document.querySelector('.swipe-card__side-btn[data-product-id="' + item.id + '"]');
      if (btn) btn.classList.add('bv-wishlisted');
    });
  }
  window.bvSwipeShare = function (btn) {
    var title = btn.getAttribute('data-title');
    var url = window.location.origin + btn.getAttribute('data-url');
    if (navigator.share) { navigator.share({ title: title, url: url }); }
    else {
      navigator.clipboard.writeText(url).then(function () {
        btn.style.background = 'rgba(34,197,94,0.4)';
        setTimeout(function () { btn.style.background = ''; }, 1500);
      });
    }
  };
  function boot() { initSwipeFeed(); restoreWishlist(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();
